// @ts-nocheck

import { environment } from 'environments';

const LOCK_EXPIRATION = 1000 * 60 * 0.5/*minutes*/;

export class Order {
  constructor(order) {
    const injector = angular.element(document).injector();
    this.Constants = injector.get('Constants');
    this.currentUser = injector.get('Auth').profile;
    order.locked_at = new Date(order.locked_at);
    Object.assign(this, order);
  }

  currentUser() {
    return this.currentUser
  }

  isTestVisit() {
    return this.flags.test;
  }

  getStatus() {
    const adminKey = _.findKey(this.Constants.AdminStatuses, {
      NumericValue: this.admin_status
    });

    return this.Constants.AdminStatuses[adminKey].StringValue;
  }

  isPending() {
    return this.admin_status != 10 && (this.status === 0 || this.status === 1);
  }

  isApproved() {
    return this.status === 3;
  }

  isRejected() {
    return this.status === 4;
  }

  isCompleted() {
    return this.status === 3 || this.status === 4 || this.status === 5;
  } // Check if visit is locked by another user


  isLocked() {
    if (!this.locked_by || !this.currentUser) {
      return false;
    }

    const isOtherUser = this.locked_by.id !== this.currentUser.id;
    return isOtherUser && (this.viewingAsLocked || !this.hasLockExpired());
  } // Check if visit is self-locked by current user

  hasLockExpired() {
    return this.getLockExpirationTime() < Date.now();
  }

  getLockInterval() {
    const ticksPerExpiration = 3;
    return LOCK_EXPIRATION * (1 / ticksPerExpiration);
  }

  getLockExpirationTime() {
    if (this.locked_at && !this.locked_at.getTime) {
      this.locked_at = new Date(this.locked_at);
    }
    return new Date(this.locked_at.getTime() + LOCK_EXPIRATION);
  }

  getTimeTilLockExpires() {
    if (this.hasLockExpired()) {
      return 0;
    }
    return this.getLockExpirationTime() - Date.now();
  }

  isLockedByMe() {
    if (this.locked_by && this.currentUser && this.locked_by.id == this.currentUser.id) return true;
    return false;
  }

  getTask(taskId) {
    if (!taskId) {
      throw new Error('Need task id');
    }

    if (!this.order_lines || !this.order_lines.length) {
      throw new Error('No orderline for this order');
    }

    let task;

    for (const stage of this.order_lines[0].stages) {
      task = _.find(stage.tasks, {
        type: taskId
      });

      if (task) {
        break;
      }
    }

    return task;
  }

  isTaskComplete(taskId) {
    if (!taskId) {
      throw new Error('Need task id');
    }

    const task = this.getTask(taskId);
    return task.status === 3 || task.status === 5;
  }

  updateTask(taskId, newStatus) {
    if (!taskId) {
      throw new Error('Provide task id.');
    }

    if (!newStatus) {
      throw new Error('Provide new status.');
    }

    const task = this.getTask(taskId);
    task.status = newStatus;
    return task;
  }

  needsDiagnosis() {
    const {
      code
    } = this.service;

    switch (code) {
      case 'HL':
        return true;

      default:
        break;
    }

    if (/acne/i.test(code)) {
      return true;
    }

    return false;
  }

}

window.Order = Order;
Order.$inject = ['order']
